import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { useCallback, useEffect, useMemo, useState } from 'react';
import * as sched from 'sched';

// Hook to retrieve the current auth token from the Amplify session
export const useAuth = () => {
    const { user } = useAuthenticator(ctx => [ctx.user]);
    const [token, setToken] = useState<string | null>(null);

    // This has to be a callback and not just a free export outside of this component
    // to make sure it's only called after wasm is initialized.
    //
    // otherwise you get `Uncaught TypeError: Cannot read properties of undefined (reading '__wbindgen_malloc')`
    //
    // And using a callback instead of just one value
    const getClient = useCallback(() => {
        return new sched.WrappedApiClient(process.env.API_URL ?? '');
    }, []);

    // Just a stub to prevent breaking changes everywhere this is already used
    const client = useMemo(() => {
        return getClient();
    }, [getClient]);

    useEffect(() => {
        if (!user) return;
        fetchAuthSession().then(session => {
            setToken(session.tokens?.idToken?.toString() ?? null);
        });
        // TODO - I don't know that this will fire when the token is refreshed...
    }, [user]);

    if (!process.env.API_URL) {
        throw new Error('API_URL is not defined');
    }

    return { user, token, getClient, client };
};